module.exports = __webpack_public_path__ + "img/inf.1272153a.png";